import { useState, useCallback } from 'react';

const useGeolocation = () => {
  const [locatingLoading, setLocatingLoading] = useState(false);
  const [geoLocationError, setGeoLocationError] = useState(null);
  const [location, setLocation] = useState(null);

  const getLocation = useCallback(async () => {
    // Check if browser supports Geolocation
    if (typeof window !== 'undefined' && !navigator.geolocation) {
      setGeoLocationError("Geolocation is not supported by your browser.");
      return null;
    }

    setLocatingLoading(true);
    setGeoLocationError(null);

    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setLocation(coords);
          setLocatingLoading(false);
          resolve(coords);
        },
        (err) => {
          let msg = "An error occurred.";
          if (err.code === 1) msg = "Location permission denied.";
          else if (err.code === 2) msg = "Position unavailable (Check GPS).";
          else if (err.code === 3) msg = "Location request timed out.";
          
          setGeoLocationError(msg);
          setLocatingLoading(false);
          // Resolving with null prevents the app from throwing a "React Error"
          resolve(null);
        },
        { 
          enableHighAccuracy: true, 
          timeout: 8000, 
          maximumAge: 0 
        }
      );
    });
  }, []);

  return { location, geoLocationError, locatingLoading, getLocation };
};

export default useGeolocation;